// Burger.js
import React from 'react'
import { StyledRightWrong } from './RightWrong.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle, faCheckCircle } from '@fortawesome/free-regular-svg-icons'
const RightWrong = ({ isRight, clicked }) => {
  return (
    <StyledRightWrong className={clicked ? 'clicked' : ''}>
      <FontAwesomeIcon icon={isRight ? faCheckCircle : faTimesCircle} size='2x' />
    </StyledRightWrong>
  )
}

export default RightWrong
